// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8f3e3e4f","212":"0e19e6e9","648":"63d14c20","882":"c9ef8dfd","912":"fa828600"}[chunkId] + ".chunk.css";
};